var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id == 1)?_c('template_1',{attrs:{"data":_vm.data}}):_vm._e(),(_vm.id == 2)?_c('template_2',{attrs:{"data":_vm.data}}):_vm._e(),(_vm.id == 3)?_c('template_3',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }